import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { useApi } from "@/hooks/useApi";
import { PageHeader, Section, Loading, ErrorBox } from "@/components/common/ui-bits";

const FIELDS = [
  ["name", "Nombre del negocio", "RinoTECH"], ["tax_id", "Número fiscal (EIN / Tax ID)", "00-0000000"],
  ["address", "Dirección", "Calle, ciudad, estado, código postal"], ["phone", "Teléfono", "(000) 000-0000"],
  ["email", "Correo de contacto", "info@rinotech.pro"], ["website", "Sitio web", "rinotech.pro"],
];
const clean = (v) => (v === "[PENDIENTE]" ? "" : v || "");

export default function Settings() {
  const { data, error } = useApi("/business-settings");
  const [v, setV] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (data) { setV(Object.fromEntries(FIELDS.map(([k]) => [k, clean(data[k])]))); }
  }, [data]);
  if (error) return <ErrorBox text={error} />;
  if (!v) return <Loading />;
  const save = async (e) => {
    e.preventDefault();
    if (!v.name.trim()) return toast.error("Escriba el nombre del negocio");
    setBusy(true);
    try { await api.put("/business-settings", v); toast.success("Datos del negocio guardados"); }
    catch (err) { toast.error(errMsg(err)); }
    finally { setBusy(false); }
  };
  return (
    <div className="mx-auto max-w-3xl" data-testid="settings-page">
      <PageHeader title="Configuración" subtitle="Datos del negocio que aparecen en las facturas y propuestas en PDF." />
      <Section title="Datos del negocio" testid="business-settings-section">
        <form onSubmit={save} className="grid gap-4 sm:grid-cols-2">
          {FIELDS.map(([k, label, ph]) => (
            <div key={k} className={k === "address" ? "sm:col-span-2" : ""}>
              <label className="field-label" htmlFor={`biz-${k}`}>{label}{k === "name" && " *"}</label>
              <input id={`biz-${k}`} className="field-input" value={v[k]} placeholder={ph} type={k === "email" ? "email" : "text"}
                onChange={(e) => setV({ ...v, [k]: e.target.value })} data-testid={`business-${k}-input`} />
            </div>
          ))}
          <div className="sm:col-span-2 flex justify-end">
            <Button type="submit" disabled={busy} data-testid="business-settings-save">{busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Save className="mr-2 h-4 w-4" />}Guardar</Button>
          </div>
        </form>
      </Section>
    </div>
  );
}
